import React from "react";

import RunFlowSvg from "../../assets/images/icons/steps/Run Flow f.svg";

export const RunFlowIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={RunFlowSvg}
        alt={alt || "Run Flow"}
    />
);
